"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gtmHelpBtn_SLRResetPassScreen = exports.gtmNextBtn_SLRResetPassScreen = exports.gtmCloseBtn_SLRResetPassScreen = exports.gtm_SLRAddEditPhoneScreen = exports.gtmCountryCodeBtn_SLRAddEditPhone = exports.gtmHelpBtn_SLRAddEditPhone = exports.gtmNextBtn_SLRAddEditPhone = exports.gtmCloseBtn_SLRAddEditPhone = exports.gtm_SLRCompleteLoginOTPScreen = exports.gtmPolicyBtn_SLRRSLRCompleteLoginOTPScreen = exports.gtmTOSBtn_SLRSLRCompleteLoginOTPScreen = exports.gtmBackBtn_SLRSLRCompleteLoginOTPScreen = exports.gtmContinueBtn_SLRCompleteLoginOTPScreen = exports.gtmHelpBtn_SLRCompleteLoginOTPScreen = exports.gtm_SLRLoginOTPScreen = exports.gtmResendBtn_SLRLoginOTPScreen = exports.gtmNextBtn_SLRLoginOTPScreen = exports.gtmBackBtn_SLRLoginOTPScreen = exports.gtmHelpBtn_SLRLoginOTPScreen = exports.gtmContinueBtn_SLRCompleteInfoScreen = exports.gtm_SLRCompleteInfoScreen = exports.gtmPolicyBtn_SLRCompleteInfoScreen = exports.gtmTOSBtn_SLRCompleteInfoScreen = exports.gtmCloseBtn_SLRCompleteInfoScreen = exports.gtmHelpBtn_SLRCompleteInfoScreen = exports.gtm_SLRLoginScreen = exports.gtmContactUsBtn_SLRLoginScreen = exports.gtmForgetPassBtn_SLRLoginScreen = exports.gtmNextBtn_SLRLoginScreen = exports.gtmBackBtn_SLRLoginScreen = exports.gtmWABtn_SLRLoginScreen = exports.gtmPolicyBtn_SLRLoginScreen = exports.gtmTOSBtn_SLRLoginScreen = exports.gtmCloseBtn_SLRLoginScreen = exports.gtmHelpBtn_SLRLoginScreen = exports.gtm_SLRSuccessScreen = exports.gtmContinueBtn_SLRSuccessScreen = exports.gtmAddPostBtn_SLRSuccessScreen = exports.gtmPolicyBtn_SLRSuccessScreen = exports.gtmTOSBtn_SLRSuccessScreen = exports.gtmCloseBtn_SLRSuccessScreen = exports.gtmHelpBtn_SLRSuccessScreen = exports.gtmVIBBtn_SLRMainScreen = exports.gtmWABtn_SLRMainScreen = exports.gtmPolicyBtn_SLRMainScreen = exports.gtmTOSBtn_SLRMainScreen = exports.gtmCloseBtn_SLRMainScreen = exports.gtmHelpBtn_SLRMainScreen = exports.gtmCountryCodeBtn = exports.gtmNextBtn_SLRMainScreen = void 0;
exports.gtm_SLRVIBPendingScreen = exports.gtmVIBInboxBtn_SLRVIBPendingScreen = exports.gtmContactUsBtn_SLRVIBPendingScreen = exports.gtmBackBtn_SLRVIBPendingScreen = exports.gtmHelpBtn_SLRVIBPendingScreen = exports.gtm_SLRRegistrationScreen = exports.gtmHelpBtn_SLRRegistrationScreen = exports.gtmVIBBtn_SLRRegistrationScreen = exports.gtmWABtn_SLRRegistrationScreen = exports.gtmSMSBtn_SLRRegistrationScreen = exports.gtmPolicyBtn_SLRRegistrationScreen = exports.gtmTOSBtn_SLRRegistrationScreen = exports.gtmBackBtn_SLRRegistrationScreen = exports.gtmCloseBtn_SLRRegistrationScreen = exports.gtm_SLRErrorScreen = exports.gtmContactUsBtn_SLRErrorScreen = exports.gtmRetryBtn_SLRErrorScreen = exports.gtmPolicyBtn_SLRErrorScreen = exports.gtmTOSBtn_SLRErrorScreen = exports.gtmCloseBtn_SLRErrorScreen = exports.gtmHelpBtn_SLRErrorScreen = exports.gtm_SLRResetScreen = exports.gtmEditBtn_SLRResetScreen = exports.gtmVIBtn_SLRResetScreen = exports.gtmWABtn_SLRResetScreen = exports.gtmSMSBtn_SLRResetScreen = exports.gtmPolicyBtn_SLRResetScreen = exports.gtmTOSBtn_SLRResetScreen = exports.gtmBackBtn_SLRResetScreen = exports.gtmHelpBtn_SLRResetScreen = exports.gtm_SLRSMSPendingScreen = exports.gtmSMSInboxBtn_SLRSMSPendingScreen = exports.gtmContactUsBtn_SLRSMSPendingScreen = exports.gtmEditBtn_SLRSMSPendingScreen = exports.gtmBackBtn_SLRSMSPendingScreen = exports.gtmBackBtn_SLRScreen = exports.gtmHelpBtn_SLRSMSPendingScreen = exports.gtm_SLRResetPassScreen = void 0;
const libs_1 = require("../../GTMs/libs");
/**
 * SLR Main Screen GTM
 */
const gtmNextBtn_SLRMainScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("InitLoginRegister", "NextBtn", true, true);
};
exports.gtmNextBtn_SLRMainScreen = gtmNextBtn_SLRMainScreen;
const gtmCountryCodeBtn = () => {
    (0, libs_1.trackEventWithNoCategory)("ChooseCountryCode", "CountryCodeBtn", true, true);
};
exports.gtmCountryCodeBtn = gtmCountryCodeBtn;
const gtmHelpBtn_SLRMainScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "HelpBtn", true, true);
};
exports.gtmHelpBtn_SLRMainScreen = gtmHelpBtn_SLRMainScreen;
const gtmCloseBtn_SLRMainScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("DiscardLoginRegister", "CloseBtn", true, true);
};
exports.gtmCloseBtn_SLRMainScreen = gtmCloseBtn_SLRMainScreen;
const gtmTOSBtn_SLRMainScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("TOS", "TOSBtn", true, true);
};
exports.gtmTOSBtn_SLRMainScreen = gtmTOSBtn_SLRMainScreen;
const gtmPolicyBtn_SLRMainScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Policy", "PolicyBtn", true, true);
};
exports.gtmPolicyBtn_SLRMainScreen = gtmPolicyBtn_SLRMainScreen;
const gtmWABtn_SLRMainScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("InitLoginRegister", "WABtn", true, true);
};
exports.gtmWABtn_SLRMainScreen = gtmWABtn_SLRMainScreen;
const gtmVIBBtn_SLRMainScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("InitLoginRegister", "VIBBtn", true, true);
};
exports.gtmVIBBtn_SLRMainScreen = gtmVIBBtn_SLRMainScreen;
/**
 * SLR Success Screen GTM
 */
const gtmHelpBtn_SLRSuccessScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "HelpBtn", true, true);
};
exports.gtmHelpBtn_SLRSuccessScreen = gtmHelpBtn_SLRSuccessScreen;
const gtmCloseBtn_SLRSuccessScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("DiscardLoginRegister", "CloseBtn", true, true);
};
exports.gtmCloseBtn_SLRSuccessScreen = gtmCloseBtn_SLRSuccessScreen;
const gtmTOSBtn_SLRSuccessScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("TOS", "TOSBtn", true, true);
};
exports.gtmTOSBtn_SLRSuccessScreen = gtmTOSBtn_SLRSuccessScreen;
const gtmPolicyBtn_SLRSuccessScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Policy", "PolicyBtn", true, true);
};
exports.gtmPolicyBtn_SLRSuccessScreen = gtmPolicyBtn_SLRSuccessScreen;
const gtmAddPostBtn_SLRSuccessScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("InitAddPost", "AddPostBtn", true, true);
};
exports.gtmAddPostBtn_SLRSuccessScreen = gtmAddPostBtn_SLRSuccessScreen;
const gtmContinueBtn_SLRSuccessScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "ContinueBtn", true, true);
};
exports.gtmContinueBtn_SLRSuccessScreen = gtmContinueBtn_SLRSuccessScreen;
const gtm_SLRSuccessScreen = () => {
    return {
        Close: exports.gtmCloseBtn_SLRSuccessScreen,
        Help: exports.gtmHelpBtn_SLRSuccessScreen,
        TOS: exports.gtmTOSBtn_SLRSuccessScreen,
        Policy: exports.gtmPolicyBtn_SLRSuccessScreen,
    };
};
exports.gtm_SLRSuccessScreen = gtm_SLRSuccessScreen;
/**
 * SLR Login Screen GTM
 */
const gtmHelpBtn_SLRLoginScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "HelpBtn", true, true);
};
exports.gtmHelpBtn_SLRLoginScreen = gtmHelpBtn_SLRLoginScreen;
const gtmCloseBtn_SLRLoginScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("DiscardLoginRegister", "CloseBtn", true, true);
};
exports.gtmCloseBtn_SLRLoginScreen = gtmCloseBtn_SLRLoginScreen;
const gtmTOSBtn_SLRLoginScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("TOS", "TOSBtn", true, true);
};
exports.gtmTOSBtn_SLRLoginScreen = gtmTOSBtn_SLRLoginScreen;
const gtmPolicyBtn_SLRLoginScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Policy", "PolicyBtn", true, true);
};
exports.gtmPolicyBtn_SLRLoginScreen = gtmPolicyBtn_SLRLoginScreen;
const gtmWABtn_SLRLoginScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("InitAddPost", "WABtn", true, true);
};
exports.gtmWABtn_SLRLoginScreen = gtmWABtn_SLRLoginScreen;
const gtmBackBtn_SLRLoginScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "BackBtn", true, true);
};
exports.gtmBackBtn_SLRLoginScreen = gtmBackBtn_SLRLoginScreen;
const gtmNextBtn_SLRLoginScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("SubmitLogin", "NextBtn", true, true);
};
exports.gtmNextBtn_SLRLoginScreen = gtmNextBtn_SLRLoginScreen;
const gtmForgetPassBtn_SLRLoginScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("InitForgetPassword", "ForgetPassBtn", true, true);
};
exports.gtmForgetPassBtn_SLRLoginScreen = gtmForgetPassBtn_SLRLoginScreen;
const gtmContactUsBtn_SLRLoginScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("ContactUs", "ContactUsBtn", true, true);
};
exports.gtmContactUsBtn_SLRLoginScreen = gtmContactUsBtn_SLRLoginScreen;
const gtm_SLRLoginScreen = () => {
    return {
        Back: exports.gtmBackBtn_SLRLoginScreen,
        Help: exports.gtmHelpBtn_SLRLoginScreen,
        TOS: exports.gtmTOSBtn_SLRLoginScreen,
        Policy: exports.gtmPolicyBtn_SLRLoginScreen,
    };
};
exports.gtm_SLRLoginScreen = gtm_SLRLoginScreen;
/**
 * SLR Complete Info Screen GTM
 */
const gtmHelpBtn_SLRCompleteInfoScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "HelpBtn", true, true);
};
exports.gtmHelpBtn_SLRCompleteInfoScreen = gtmHelpBtn_SLRCompleteInfoScreen;
const gtmCloseBtn_SLRCompleteInfoScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("DiscardLoginRegister", "CloseBtn", true);
};
exports.gtmCloseBtn_SLRCompleteInfoScreen = gtmCloseBtn_SLRCompleteInfoScreen;
const gtmTOSBtn_SLRCompleteInfoScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("TOS", "TOSBtn", true, true);
};
exports.gtmTOSBtn_SLRCompleteInfoScreen = gtmTOSBtn_SLRCompleteInfoScreen;
const gtmPolicyBtn_SLRCompleteInfoScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Policy", "PolicyBtn", true, true);
};
exports.gtmPolicyBtn_SLRCompleteInfoScreen = gtmPolicyBtn_SLRCompleteInfoScreen;
const gtm_SLRCompleteInfoScreen = () => {
    return {
        Close: exports.gtmCloseBtn_SLRCompleteInfoScreen,
        Help: exports.gtmHelpBtn_SLRCompleteInfoScreen,
        TOS: exports.gtmTOSBtn_SLRCompleteInfoScreen,
        Policy: exports.gtmPolicyBtn_SLRCompleteInfoScreen,
    };
};
exports.gtm_SLRCompleteInfoScreen = gtm_SLRCompleteInfoScreen;
const gtmContinueBtn_SLRCompleteInfoScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "ContinueBtn", true);
};
exports.gtmContinueBtn_SLRCompleteInfoScreen = gtmContinueBtn_SLRCompleteInfoScreen;
/**
 * SLR Login OTP Screen GTM
 */
const gtmHelpBtn_SLRLoginOTPScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "HelpBtn", true, true);
};
exports.gtmHelpBtn_SLRLoginOTPScreen = gtmHelpBtn_SLRLoginOTPScreen;
const gtmBackBtn_SLRLoginOTPScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "BackBtn", true, true);
};
exports.gtmBackBtn_SLRLoginOTPScreen = gtmBackBtn_SLRLoginOTPScreen;
const gtmNextBtn_SLRLoginOTPScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("SubmitLogin", "NextBtn", true, true);
};
exports.gtmNextBtn_SLRLoginOTPScreen = gtmNextBtn_SLRLoginOTPScreen;
const gtmResendBtn_SLRLoginOTPScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Policy", "ResendBtn", true, true);
};
exports.gtmResendBtn_SLRLoginOTPScreen = gtmResendBtn_SLRLoginOTPScreen;
const gtm_SLRLoginOTPScreen = () => {
    return {
        Back: exports.gtmBackBtn_SLRLoginOTPScreen,
        Help: exports.gtmHelpBtn_SLRLoginOTPScreen,
    };
};
exports.gtm_SLRLoginOTPScreen = gtm_SLRLoginOTPScreen;
/**
 * SLR Complete Login OTP Screen GTM
 */
const gtmHelpBtn_SLRCompleteLoginOTPScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "HelpBtn", true, true);
};
exports.gtmHelpBtn_SLRCompleteLoginOTPScreen = gtmHelpBtn_SLRCompleteLoginOTPScreen;
const gtmContinueBtn_SLRCompleteLoginOTPScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("SubmitLoginOTP", "ContinueBtn", true);
};
exports.gtmContinueBtn_SLRCompleteLoginOTPScreen = gtmContinueBtn_SLRCompleteLoginOTPScreen;
const gtmBackBtn_SLRSLRCompleteLoginOTPScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "BackBtn", true, true);
};
exports.gtmBackBtn_SLRSLRCompleteLoginOTPScreen = gtmBackBtn_SLRSLRCompleteLoginOTPScreen;
const gtmTOSBtn_SLRSLRCompleteLoginOTPScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("TOS", "TOSBtn", true, true);
};
exports.gtmTOSBtn_SLRSLRCompleteLoginOTPScreen = gtmTOSBtn_SLRSLRCompleteLoginOTPScreen;
const gtmPolicyBtn_SLRRSLRCompleteLoginOTPScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Policy", "PolicyBtn", true, true);
};
exports.gtmPolicyBtn_SLRRSLRCompleteLoginOTPScreen = gtmPolicyBtn_SLRRSLRCompleteLoginOTPScreen;
const gtm_SLRCompleteLoginOTPScreen = () => {
    return {
        Back: exports.gtmBackBtn_SLRSLRCompleteLoginOTPScreen,
        Help: exports.gtmHelpBtn_SLRCompleteLoginOTPScreen,
        TOS: exports.gtmTOSBtn_SLRSLRCompleteLoginOTPScreen,
        Policy: exports.gtmPolicyBtn_SLRRSLRCompleteLoginOTPScreen,
    };
};
exports.gtm_SLRCompleteLoginOTPScreen = gtm_SLRCompleteLoginOTPScreen;
/**
 * SLR Edit Phone Number Screen
 */
const gtmCloseBtn_SLRAddEditPhone = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "CloseBtn", true, true);
};
exports.gtmCloseBtn_SLRAddEditPhone = gtmCloseBtn_SLRAddEditPhone;
const gtmNextBtn_SLRAddEditPhone = () => {
    (0, libs_1.trackEventWithNoCategory)("AddEditPhone", "NextBtn", true, true);
};
exports.gtmNextBtn_SLRAddEditPhone = gtmNextBtn_SLRAddEditPhone;
const gtmHelpBtn_SLRAddEditPhone = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "HelpBtn", true, true);
};
exports.gtmHelpBtn_SLRAddEditPhone = gtmHelpBtn_SLRAddEditPhone;
const gtmCountryCodeBtn_SLRAddEditPhone = () => {
    (0, libs_1.trackEventWithNoCategory)("ChooseCountryCode", "CountryCodeBtn", true, true);
};
exports.gtmCountryCodeBtn_SLRAddEditPhone = gtmCountryCodeBtn_SLRAddEditPhone;
const gtm_SLRAddEditPhoneScreen = () => {
    return {
        Close: exports.gtmCloseBtn_SLRAddEditPhone,
        Help: exports.gtmHelpBtn_SLRAddEditPhone,
    };
};
exports.gtm_SLRAddEditPhoneScreen = gtm_SLRAddEditPhoneScreen;
/**
 * SLR Reset Password Screen
 */
const gtmCloseBtn_SLRResetPassScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "CloseBtn", true, true);
};
exports.gtmCloseBtn_SLRResetPassScreen = gtmCloseBtn_SLRResetPassScreen;
const gtmNextBtn_SLRResetPassScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("ResetPassword", "NextBtn", true, true);
};
exports.gtmNextBtn_SLRResetPassScreen = gtmNextBtn_SLRResetPassScreen;
const gtmHelpBtn_SLRResetPassScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "HelpBtn", true, true);
};
exports.gtmHelpBtn_SLRResetPassScreen = gtmHelpBtn_SLRResetPassScreen;
const gtm_SLRResetPassScreen = () => {
    return {
        Close: exports.gtmCloseBtn_SLRResetPassScreen,
        Help: exports.gtmHelpBtn_SLRResetPassScreen,
    };
};
exports.gtm_SLRResetPassScreen = gtm_SLRResetPassScreen;
/**
 *  SLR SMS Pending Screen
 */
const gtmHelpBtn_SLRSMSPendingScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "HelpBtn", true, true);
};
exports.gtmHelpBtn_SLRSMSPendingScreen = gtmHelpBtn_SLRSMSPendingScreen;
const gtmBackBtn_SLRScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "BackBtn", true, true);
};
exports.gtmBackBtn_SLRScreen = gtmBackBtn_SLRScreen;
const gtmBackBtn_SLRSMSPendingScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "BackBtn", true, true);
};
exports.gtmBackBtn_SLRSMSPendingScreen = gtmBackBtn_SLRSMSPendingScreen;
const gtmEditBtn_SLRSMSPendingScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "EditBtn", true, true);
};
exports.gtmEditBtn_SLRSMSPendingScreen = gtmEditBtn_SLRSMSPendingScreen;
const gtmContactUsBtn_SLRSMSPendingScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("ContactUs", "ContactUsBtn", true, true);
};
exports.gtmContactUsBtn_SLRSMSPendingScreen = gtmContactUsBtn_SLRSMSPendingScreen;
const gtmSMSInboxBtn_SLRSMSPendingScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("SMSInbox", "SMSInboxBtn", true, true);
};
exports.gtmSMSInboxBtn_SLRSMSPendingScreen = gtmSMSInboxBtn_SLRSMSPendingScreen;
const gtm_SLRSMSPendingScreen = () => {
    return {
        Back: exports.gtmBackBtn_SLRSMSPendingScreen,
        Help: exports.gtmHelpBtn_SLRSMSPendingScreen,
    };
};
exports.gtm_SLRSMSPendingScreen = gtm_SLRSMSPendingScreen;
/**
 * SLR Reset Screen
 */
const gtmHelpBtn_SLRResetScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "HelpBtn", true, true);
};
exports.gtmHelpBtn_SLRResetScreen = gtmHelpBtn_SLRResetScreen;
const gtmBackBtn_SLRResetScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "BackBtn", true, true);
};
exports.gtmBackBtn_SLRResetScreen = gtmBackBtn_SLRResetScreen;
const gtmTOSBtn_SLRResetScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("TOS", "TOSBtn", true, true);
};
exports.gtmTOSBtn_SLRResetScreen = gtmTOSBtn_SLRResetScreen;
const gtmPolicyBtn_SLRResetScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Policy", "PolicyBtn", true, true);
};
exports.gtmPolicyBtn_SLRResetScreen = gtmPolicyBtn_SLRResetScreen;
const gtmSMSBtn_SLRResetScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("InitResetPassword", "SMSBtn", true, true);
};
exports.gtmSMSBtn_SLRResetScreen = gtmSMSBtn_SLRResetScreen;
const gtmWABtn_SLRResetScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("InitResetPassword", "WABtn", true, true);
};
exports.gtmWABtn_SLRResetScreen = gtmWABtn_SLRResetScreen;
const gtmVIBtn_SLRResetScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("InitResetPassword", "VIBBtn", true, true);
};
exports.gtmVIBtn_SLRResetScreen = gtmVIBtn_SLRResetScreen;
const gtmEditBtn_SLRResetScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "EditBtn", true, true);
};
exports.gtmEditBtn_SLRResetScreen = gtmEditBtn_SLRResetScreen;
const gtm_SLRResetScreen = () => {
    return {
        Back: exports.gtmBackBtn_SLRResetScreen,
        Help: exports.gtmHelpBtn_SLRResetScreen,
        TOS: exports.gtmTOSBtn_SLRResetScreen,
        Policy: exports.gtmPolicyBtn_SLRResetScreen,
    };
};
exports.gtm_SLRResetScreen = gtm_SLRResetScreen;
/**
 * SLR Error Screen
 */
const gtmHelpBtn_SLRErrorScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "HelpBtn", true, true);
};
exports.gtmHelpBtn_SLRErrorScreen = gtmHelpBtn_SLRErrorScreen;
const gtmCloseBtn_SLRErrorScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("DiscardLoginRegister", "CloseBtn", true, true);
};
exports.gtmCloseBtn_SLRErrorScreen = gtmCloseBtn_SLRErrorScreen;
const gtmTOSBtn_SLRErrorScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("TOS", "TOSBtn", true, true);
};
exports.gtmTOSBtn_SLRErrorScreen = gtmTOSBtn_SLRErrorScreen;
const gtmPolicyBtn_SLRErrorScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Policy", "PolicyBtn", true, true);
};
exports.gtmPolicyBtn_SLRErrorScreen = gtmPolicyBtn_SLRErrorScreen;
const gtmRetryBtn_SLRErrorScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("RetryLoginRegister", "RetryBtn", true, true);
};
exports.gtmRetryBtn_SLRErrorScreen = gtmRetryBtn_SLRErrorScreen;
const gtmContactUsBtn_SLRErrorScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("InitContactUs", "ContactUsBtn_SLRErrorScreen", true, true);
};
exports.gtmContactUsBtn_SLRErrorScreen = gtmContactUsBtn_SLRErrorScreen;
const gtm_SLRErrorScreen = () => {
    return {
        Close: exports.gtmCloseBtn_SLRErrorScreen,
        Help: exports.gtmHelpBtn_SLRErrorScreen,
        TOS: exports.gtmTOSBtn_SLRErrorScreen,
        Policy: exports.gtmPolicyBtn_SLRErrorScreen,
    };
};
exports.gtm_SLRErrorScreen = gtm_SLRErrorScreen;
/**
 * SLR Registration Screen
 */
const gtmCloseBtn_SLRRegistrationScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "CloseBtn", true, true);
};
exports.gtmCloseBtn_SLRRegistrationScreen = gtmCloseBtn_SLRRegistrationScreen;
const gtmBackBtn_SLRRegistrationScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "BackBtn", true, true);
};
exports.gtmBackBtn_SLRRegistrationScreen = gtmBackBtn_SLRRegistrationScreen;
const gtmTOSBtn_SLRRegistrationScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("TOS", "TOSBtn", true, true);
};
exports.gtmTOSBtn_SLRRegistrationScreen = gtmTOSBtn_SLRRegistrationScreen;
const gtmPolicyBtn_SLRRegistrationScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Policy", "PolicyBtn", true, true);
};
exports.gtmPolicyBtn_SLRRegistrationScreen = gtmPolicyBtn_SLRRegistrationScreen;
const gtmSMSBtn_SLRRegistrationScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("InitRegister", "SMSBtn", true, true);
};
exports.gtmSMSBtn_SLRRegistrationScreen = gtmSMSBtn_SLRRegistrationScreen;
const gtmWABtn_SLRRegistrationScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("InitRegister", "WABtn", true, true);
};
exports.gtmWABtn_SLRRegistrationScreen = gtmWABtn_SLRRegistrationScreen;
const gtmVIBBtn_SLRRegistrationScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("InitRegister", "VIBBtn", true, true);
};
exports.gtmVIBBtn_SLRRegistrationScreen = gtmVIBBtn_SLRRegistrationScreen;
const gtmHelpBtn_SLRRegistrationScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "HelpBtn", true, true);
};
exports.gtmHelpBtn_SLRRegistrationScreen = gtmHelpBtn_SLRRegistrationScreen;
const gtm_SLRRegistrationScreen = () => {
    return {
        Back: exports.gtmBackBtn_SLRRegistrationScreen,
        Close: exports.gtmCloseBtn_SLRRegistrationScreen,
        Help: exports.gtmHelpBtn_SLRRegistrationScreen,
        TOS: exports.gtmTOSBtn_SLRRegistrationScreen,
        Policy: exports.gtmPolicyBtn_SLRRegistrationScreen,
    };
};
exports.gtm_SLRRegistrationScreen = gtm_SLRRegistrationScreen;
/**
 *  SLR Viber Pending Screen
 */
const gtmHelpBtn_SLRVIBPendingScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Help", "HelpBtn", true, true);
};
exports.gtmHelpBtn_SLRVIBPendingScreen = gtmHelpBtn_SLRVIBPendingScreen;
const gtmBackBtn_SLRVIBPendingScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("Browse", "BackBtn", true, true);
};
exports.gtmBackBtn_SLRVIBPendingScreen = gtmBackBtn_SLRVIBPendingScreen;
const gtmContactUsBtn_SLRVIBPendingScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("ContactUs", "ContactUsBtn", true, true);
};
exports.gtmContactUsBtn_SLRVIBPendingScreen = gtmContactUsBtn_SLRVIBPendingScreen;
const gtmVIBInboxBtn_SLRVIBPendingScreen = () => {
    (0, libs_1.trackEventWithNoCategory)("SMSInbox", "VIBInboxBtn", true, true);
};
exports.gtmVIBInboxBtn_SLRVIBPendingScreen = gtmVIBInboxBtn_SLRVIBPendingScreen;
const gtm_SLRVIBPendingScreen = () => {
    return {
        Back: exports.gtmBackBtn_SLRVIBPendingScreen,
        Help: exports.gtmHelpBtn_SLRVIBPendingScreen,
    };
};
exports.gtm_SLRVIBPendingScreen = gtm_SLRVIBPendingScreen;
